declare global {
  interface Window {
    DJANGO_REQUEST?: {
      appBrand?: {
        name?: string
      }
    }
  }
}

/**
 * The product name to show in copy.
 *
 * Inside a branded app the product carries that brand's name, and GrainFox is named only in
 * the 'powered by' lockup. Plain modules use this directly; components get it as `$appName`.
 */
export default function appName(): string {
  return window.DJANGO_REQUEST?.appBrand?.name || 'GrainFox';
}
